import { useTranslation } from 'react-i18next';
import { GAME_STATES } from '../utils/constants';
import Card from './Card';

export const QuestionCountdown = ({ gameState, countdown }) => {
	const { t } = useTranslation();
	return (
		<div className='container-game flex flex-col items-center justify-center min-h-screen'>
			<Card className='text-center py-12 px-8'>
				<h2 className='text-2xl font-bold mb-6'>{t('questionCountdownView.title')}</h2>
				<div className='text-8xl font-bold text-primary-500 animate-pulse-slow'>{countdown}</div>
				<p className='mt-6 text-xl'>
					{gameState === GAME_STATES.COUNTDOWN_NEXT
						? t('questionCountdownView.nextQuestionMessage')
						: t('questionCountdownView.gameStartMessage')}
				</p>
			</Card>
		</div>
	);
};
